import React, { Component } from 'react'
import Link from 'gatsby-link'
import {Title} from '../Title'
import { renderVideos } from '../utils'

import './video-list.css'

class VideoList extends Component {

  render () {
    let data = this.props.data;
    let videos = renderVideos(data.videos);
    
    return (
      <div>
        <Title name={data.title}></Title>
        {videos}
      </div>
    )

  }
}


export default {VideoList}



// WEBPACK FOOTER //
// ./src/components/VideoList/index.js